import {createIcon} from '@chakra-ui/react'

export const JaenLogo = createIcon({
  displayName: 'JaenLogo',
  viewBox: '0 0 512 512',
  path: (
    <>
      <path
        id="squerl1"
        fill="black"
        d="M 458.63,53.50
          C 410.33,5.38 340.88,0.00 256.00,0.00
            171.02,0.00 101.46,5.44 53.17,53.69
            4.90,101.92 0.00,171.36 0.00,256.25
            0.00,341.15 4.90,410.62 53.19,458.86
            101.47,507.12 171.03,512.00 256.00,512.00
            340.97,512.00 410.51,507.12 458.80,458.86
            507.09,410.61 512.00,341.15 512.00,256.25
            512.00,171.26 507.04,101.73 458.63,53.50
            458.63,53.50 458.63,53.50 458.63,53.50 Z"
      />
      <path
        id="snek1"
        fill="white"
        d="M 132.00,367.32
          C 132.57,368.72 132.92,370.26 133.74,371.49
            136.27,375.31 138.72,379.22 141.65,382.72
            156.36,400.33 174.57,413.37 195.35,422.83
            224.57,436.12 255.19,440.65 287.19,436.75
            309.72,434.04 330.93,427.00 349.88,416.50
            376.03,402.25 398.16,381.55 414.10,356.54
            431.16,329.96 440.66,300.94 442.60,269.48
            442.83,265.74 442.95,261.96 442.95,258.16
            442.95,235.47 438.73,213.77 431.03,193.92
            416.37,155.51 391.76,125.07 356.99,103.19
            318.24,78.80 275.94,69.80 230.53,76.08
            203.48,79.82 178.45,89.25 155.43,103.90
            129.05,120.69 108.15,142.80 92.73,169.94
            77.53,196.68 69.16,225.48 67.88,256.28
            67.76,259.05 67.70,261.84 67.70,264.65
            67.70,284.82 70.84,304.26 76.67,322.33
            77.89,326.18 79.17,330.16 81.25,333.57
            88.78,345.98 104.35,350.15 117.43,343.60
            129.96,337.32 135.75,322.16 130.64,308.87
            122.10,286.66 119.60,263.75 122.94,240.25
            126.34,216.35 135.45,194.73 150.06,175.46
            164.96,155.67 185.08,140.02 208.38,130.61
            236.67,118.98 265.82,116.56 295.56,123.70
            330.31,132.04 358.51,150.69 379.37,179.65
            402.05,211.15 410.83,246.50 405.95,285.06
            402.50,312.29 392.33,336.94 375.06,358.20
            341.99,398.94 298.74,418.16 246.38,416.45
            214.77,415.41 186.13,404.83 160.11,387.14
            152.02,381.63 144.45,375.37 136.61,369.48
            135.32,368.52 133.90,367.75 132.53,366.88
            132.36,367.03 132.18,367.18 132.00,367.32 Z"
      />
      <path
        id="cross1"
        fill="white"
        d="M 341.13,179.44
          C 341.13,179.44 356.01,192.55 356.01,192.55
            359.08,195.26 368.79,203.34 370.34,206.85
            373.37,213.69 363.90,218.78 359.63,223.18
            359.63,223.18 332.12,248.86 332.12,248.86
            328.92,252.05 323.61,256.74 323.90,261.66
            324.14,265.65 330.36,273.16 332.96,276.32
            332.96,276.32 358.43,305.64 358.43,305.64
            361.97,310.16 368.63,317.82 366.55,323.93
            365.47,327.11 350.35,341.58 346.56,345.95
            341.85,351.37 335.70,359.99 328.43,361.57
            320.15,363.38 312.39,356.93 306.40,352.15
            299.51,346.66 271.31,323.12 264.68,321.50
            259.84,320.32 256.41,324.50 253.42,327.68
            253.42,327.68 234.39,351.37 234.39,351.37
            227.48,359.58 221.44,367.14 214.81,367.94
            205.11,367.98 190.34,359.07 181.52,353.27
            176.74,350.13 166.23,344.33 165.22,338.45
            164.41,333.71 168.66,327.76 171.13,323.96
            178.34,312.83 186.57,301.63 194.72,293.15
            198.27,288.57 209.06,280.97 206.73,274.49
            205.28,270.46 196.02,265.42 192.54,262.81
            192.54,262.81 164.99,241.86 164.99,241.86
            159.12,237.10 149.39,232.76 151.30,224.18
            153.15,215.87 187.63,173.57 193.97,171.23
            200.76,169.72 234.58,196.13 242.12,201.97
            246.16,205.09 255.55,213.80 260.48,213.68
            266.13,213.54 274.68,203.49 278.54,199.52
            288.30,189.49 315.55,164.46 317.98,165.10
            320.11,164.43 334.08,173.73 341.13,179.44 Z"
      />
    </>
  )
})
